<template>
  <v-container grid-list-xl class="pa-5">
    <m-card-list
      titleLock="Kuesioner"
      descLock=""
      two-line
      title="Riwayat Kuesioner"
      label-cari="Cari Kuesioner"
      search
      :items="items"
      :headers="headers"
      :refresh="false"
      @refresh="load"
      :page="page"
      footer
      @search="
        (search) => {
          textSearch = search
          load()
        }
      "
      @change:page="
        (pg) => {
          cp = pg
          load()
        }
      "
    >
      <template v-slot:items="{ props, item }">
        <tr>
          <td class="py-3">
            <span class="font-weight-medium"> {{ getDeepObj(item, 'kuesioner.nama') }}</span>
          </td>
          <td class="py-3">
            <span class="font-weight-medium"> {{ getDeepObj(item, 'tgl') | toD }}</span>
          </td>
          <td class="py-3">
            <span class="font-weight-medium">
              {{ getDeepObj(item, 'kuesioner.m_tipe_pengisian.keterangan') }}
            </span>
          </td>
          <td>
            <v-chip :color="!item.wkt_selesai ? 'error' : 'success'" outlined small>
              {{ item.wkt_selesai ? 'Mengisi' : 'Belum Mengisi' }}
            </v-chip>
          </td>
          <td class="py-3">
            <span class="font-weight-medium"> {{ getDeepObj(item, 'wkt_selesai') | toDT }}</span>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="onEdit(item)" v-on="on">
                  <v-icon>
                    {{ isNow(item) ? 'mdi-file-edit' : 'mdi-eye' }}
                  </v-icon>
                </v-btn>
              </template>
              <span>
                {{ isNow(item) ? 'Edit Kuesioner' : 'Lihat Kuesioner' }}
              </span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </m-card-list>
    <PopupKuesioner ref="popup" @reload="load" />
  </v-container>
</template>

<script>
import BlockCard from '@/components/BlockCard.vue'

import { M_STATUS } from '../const'
import { mapForMaster, toSD } from '@/tools'
import PopupKuesioner from '../components/PopupKuesioner.vue'
export default {
  components: {
    PopupKuesioner,
    BlockCard,
  },
  data() {
    return {
      textSearch: '',
      cp: 1,
      page: null,
      items: [],
      M_STATUS: M_STATUS,
      filters: {},
      modal: false,
      headers: [
        { text: 'Judul Kuesioner', align: 'left', value: 'nama', sortable: false },
        { text: 'Tanggal Kirim Kuesioner', align: 'left', value: 'wkt_mulai', sortable: false },
        { text: 'Tipe Waktu Kuesioner', align: 'left', value: 'k_tipe_pengisian', sortable: false },
        { text: 'Status Pengisian', align: 'left', value: 'status_tayang', sortable: false },
        { text: 'Tgl Simpan Kuesioner', align: 'left', value: 'updated_at', sortable: false },
        { text: '', align: 'left', sortable: false },
      ],
      M_PERIOD: {
        1: '1x Pengisian',
        2: 'Harian',
        3: 'Mingguan',
        4: 'Bulanan',
      },
      modelStatus: {
        1: 'Draft',
        2: 'Akan Tayang',
        3: 'Sedang Tayang',
        4: 'Selesai',
        5: 'Non-aktif',
      },
    }
  },
  activated() {
    this.load()
  },
  methods: {
    mapForMaster,
    load() {
      this.$store
        .dispatch('kuesioner/history', {
          organisasi_id: this.organisasi_id,
          params: Object.assign(
            {},
            {
              page: this.cp,
              keyword: this.textSearch,
            },
            this.filters
          ),
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    onFilter() {
      this.load()
      this.modal = false
    },
    onReset() {
      this.filters = {}
      this.load()
      this.modal = false
    },
    isNow(item) {
      const now = toSD(new Date())
      const tglMulai = toSD(new Date(item.tgl))
      return now === tglMulai
    },
    onEdit(item) {
      // const now = new Date()
      // const tglMulaiDate = new Date(item.tgl)
      // tglMulaiDate.setDate(tglMulaiDate.getDate() + 1)
      // const tglMulai = tglMulaiDate

      // if (
      //   !item.wkt_selesai && (new Date(now) > new Date(tglMulai))
      // ) {
      //   this.$error('Kuesioner belum bisa diisi, karena hari sudah lewat atau belum dimulai.')
      //   return
      // }

      this.$store
        .dispatch('kuesioner/getQuizUser', {
          kuesioner_id: item.kuesioner_respons_id,
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.$refs.popup.open(Object.assign({}, data, { id: item.kuesioner_respons_id, is_edit: true }))
        })
    },
  },
}
</script>
<style scoped>
.elevation-custom {
  -webkit-box-shadow: 0px 0px 10px 3px #4362be56 !important;
}
</style>
